<div id="my-app">

     <div id="audioTimer" *ngIf="audioBlobUrl">
      <div><i class="fa fa-circle text-danger Blink"></i> 
<!--         
        &nbsp; {{ audioRecordedTime }}  -->
      
      </div> 
</div>